import React, { useEffect } from 'react';
import Form, { useForm } from '../../../molecules/Form';
import Button from '../../../molecules/Button';
import { StyledTabSetComponents } from '../TabSetComponents.styles';
import Field from '../../Field';

const Sale = ({ title, data, deviceId, completeData, onSubmit }) => {
  const [form] = useForm();

  const handleSubmit = async e => {
    const payload = {
      id: deviceId,
      configuration: {
        ...completeData?.configuration,
        screen_times: {
          ...completeData?.configuration?.screen_times,
          credit_debit_sale: {
            tap_screen_time: e?.tapTimer,
            tap_screen_counter: e?.tapCounter,
            pin_screen_time: e?.pinTimer,
            pin_screen_counter: e?.pinCounter,
            other_screen_time: e?.otherTimer,
            other_screen_counter: e?.otherCounter,
          },
        },
      },
    };

    onSubmit(payload);
  };

  useEffect(() => {
    form.setFieldsValue({
      pinTimer: data?.pin_screen_time,
      pinCounter: data?.pin_screen_counter,
      tapTimer: data?.tap_screen_time,
      tapCounter: data?.tap_screen_counter,
      otherTimer: data?.other_screen_time,
      otherCounter: data?.other_screen_counter,
    });
  }, [data, form]);
  return (
    <StyledTabSetComponents form={form} onSubmit={handleSubmit}>
      <div className="tab-body-header">
        <strong className="title">{title}</strong>
        {/* <div className="switch-wrap">
                    <Form.Item label="Visible" name="visible">
                        <Switch />
                    </Form.Item>
                    <Form.Item label="Lock" name="Lock">
                        <Switch label="Lock" />
                    </Form.Item>
                </div> */}
      </div>
      <div className="tab-body-body">
        <div className="terminal-switch">
          <div className="terminal-text">
            <strong className="text">Pin Screen</strong>
          </div>
          <div className="combine-fields">
            <div className="form-control-custom">
              <Form.Item label="Timer" type="text" rounded name="pinTimer" lg placeholder="50" suffix="sec">
                <Field />
              </Form.Item>
            </div>
            <div className="form-control-custom">
              <Form.Item label="Counter" type="text" rounded name="pinCounter" lg placeholder="03">
                <Field />
              </Form.Item>
            </div>
          </div>
        </div>
        <div className="terminal-switch">
          <div className="terminal-text">
            <strong className="text">Tap Screen</strong>
          </div>
          <div className="combine-fields">
            <div className="form-control-custom">
              <Form.Item label="Timer" type="text" rounded name="tapTimer" lg placeholder="50" suffix="sec">
                <Field />
              </Form.Item>
            </div>
            <div className="form-control-custom">
              <Form.Item label="Counter" type="text" rounded name="tapCounter" lg placeholder="03">
                <Field />
              </Form.Item>
            </div>
          </div>
        </div>
      </div>
      <div className="tab-body-body">
        <div className="terminal-switch">
          <div className="terminal-text">
            <strong className="text">Other Screens</strong>
          </div>
          <div className="combine-fields">
            <div className="form-control-custom">
              <Form.Item label="Timer" type="text" rounded name="otherTimer" lg placeholder="50" suffix="sec">
                <Field />
              </Form.Item>
            </div>
            <div className="form-control-custom">
              <Form.Item label="Counter" type="text" rounded name="otherCounter" lg placeholder="03">
                <Field />
              </Form.Item>
            </div>
          </div>
        </div>
      </div>

      <div className="submission-wrapper">
        <Button width="140px">Confirm</Button>
      </div>
    </StyledTabSetComponents>
  );
};

export default Sale;
